import LogoTecno from '../../tecnologo.png'
import React from "react";
import Alert from "../ui/feedback/Alert";
import {useSearchParams} from "react-router-dom";

class PasswordReset extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            username: ""
        }
    }

    async resetPassword(token) {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': 'http://localhost:3000'
            },
            body: JSON.stringify({
                token: token,
                newPassword: this.state.password
            })
        }

        if (this.state.password !== this.state.confirm) {
            this.setState({
                status: <Alert color="red" header="Le password non corrispondono!"
                               description="Controlla di aver digitato bene la password"/>
            })

            return
        }

        const regex = new RegExp('^.*(?=.*[A-Z])(?=.*\\d)(?=.*[@$!(){}\\[\\]#%*?&])[A-Za-z\\d@$!(){}\\[\\]#%*?&]{8,}.*$');
        if (!regex.test(this.state.password)) {
            this.setState({
                status: <Alert color="red" header="Password insicura!"
                               description="La password inserita non è sicura. Inserisci una password di almeno 8 caratteri,
                               con almeno una lettera maiuscola, un numero e un carattere speciale fra questi: @$#!%*?&"/>
            })

            return
        }

        await fetch(window.location.protocol + "//" + window.location.host + "/passwordreset/reset", requestOptions)
            .then(async response => await response.json())
            .then(data => {

                if (data.status === "EXPIRED_REQUEST") {
                    this.setState({
                        status: <Alert color="red" header="Richiesta scaduta!"
                                       description="La richiesta è scaduta, inviane una nuova per resettare la password."/>
                    })
                    return;
                }

                if (data.status === "SAME_PASSWORD") {
                    this.setState({
                        status: <Alert color="red" header="Scegli una password diversa"
                                       description="Inserisci una password diversa da quella precedente!"/>
                    })
                    return;
                }

                if (data.success === null) {
                    this.setState({
                        status: <Alert color="red" header="Errore interno!"
                                       description="C'è stato un errore interno, riprova!"/>
                    })
                    return;
                }

                this.setState({
                    status: <Alert color="green" header="Successo!"
                                   description={"Hai cambiato la tua password con sucecsso!"}/>
                })
            })
    };

    componentDidMount() {
        document.title = this.props.title
    }

    render() {
        if (this.props.params.get("token") === null)
            return null

        return (
            <div>
                <div className="flex flex-col items-center min-h-screen pt-6 sm:justify-center sm:pt-0 bg-gray-50">
                    <div>
                        <h3 className="text-4xl font-bold text-green-600">
                            <img src={LogoTecno} className="mx-auto h-32 w-auto" alt="Logo TecnoRoleplay"/>
                        </h3>
                    </div>

                    <form method="POST" onSubmit={event => {
                        this.resetPassword(this.props.params.get("token"))
                        event.preventDefault()
                    }}>
                        <div className="w-full sm:max-w-lg sm:rounded-lg">
                            {this.state.status}
                            <div
                                className="w-full px-16 py-16 mt-6 overflow-hidden bg-white shadow-md">
                                <div>
                                    <div>
                                        <h3 className="text-2xl font-bold text-gray-900">
                                            Un ultimo passaggio
                                        </h3>


                                        <p className="block py-6 font-medium text-gray-600">
                                            Inserisci una nuova password per il tuo account.
                                            Ricordati di scegliere una password con almeno 8 caratteri alfanumerici,
                                            un numero e un carattere speciale.
                                        </p>
                                    </div>

                                    <label
                                        htmlFor="name"
                                        className="block text-sm bold font-medium text-gray-700 undefined"
                                    >
                                        Nuova password
                                    </label>
                                    <div className="flex flex-col items-start">
                                        <input
                                            type="password"
                                            name="username"
                                            className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-green-300 focus:ring focus:ring-green-200 focus:ring-opacity-50"
                                            onChange={event => this.setState({password: event.target.value})}
                                        />
                                    </div>

                                    <br/>

                                    <label
                                        htmlFor="name"
                                        className="block text-sm bold font-medium text-gray-700 undefined"
                                    >
                                        Conferma password
                                    </label>
                                    <div className="flex flex-col items-start">
                                        <input
                                            type="password"
                                            name="username"
                                            className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-green-300 focus:ring focus:ring-green-200 focus:ring-opacity-50"
                                            onChange={event => this.setState({confirm: event.target.value})}
                                        />
                                    </div>
                                </div>
                                <div className="flex items-center mt-4">
                                    <button
                                        type="submit"
                                        className="w-full px-4 py-2 tracking-wide text-white bg-gradient-to-r from-green-500 to-green-700 rounded-md hover:bg-green-600 focus:outline-none focus:bg-green-600">
                                        Continua
                                    </button>
                                </div>
                                <div className="flex items-center w-full my-4">
                                    <hr className="w-full"/>
                                </div>
                                <div className="flex font-small text-gray-500 text-xs">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

const Reset = (props) => {
    const [searchParams] = useSearchParams();

    return <PasswordReset
        {...props}
        params={searchParams}
    />
}

export default Reset
